"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
const fit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      fontSize: (0, _constant.get)('fontSizes.s'),
      borderRadius: (0, _constant.get)('borderRadius.s'),
      padding: props => "".concat((0, _constant.get)('space.6')(props), " ").concat((0, _constant.get)('space.8')(props))
    },
    medium: {
      fontSize: (0, _constant.get)('fontSizes.m'),
      borderRadius: (0, _constant.get)('borderRadius.m'),
      padding: props => "".concat((0, _constant.get)('space.8')(props), " ").concat((0, _constant.get)('space.12')(props))
    },
    large: {
      fontSize: (0, _constant.get)('fontSizes.l'),
      borderRadius: (0, _constant.get)('borderRadius.l'),
      padding: props => "".concat((0, _constant.get)('space.12')(props), " ").concat((0, _constant.get)('space.16')(props))
    }
  }
});
const variants = {
  fit
};
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n"])), props => props.width ? "".concat(props.width, "%") : '100%');
const Area = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: relative;\n  transform: translateX(0);\n  border-radius: ", ";\n"])), (0, _constant.get)('borderRadius.l'));
const TextArea = _styledComponents["default"].textarea.attrs(() => ({
  autoCorrect: 'off',
  autoCapitalize: 'none',
  spellCheck: 'false'
}))(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  ", "\n  height: auto;\n  box-sizing: border-box;\n  border: 1px solid;\n  width: 100%;\n  border-color: ", ";\n  transition: 0.2s ease;\n  transition-property: border, background-color;\n  color: ", ";\n  box-shadow: none;\n  font-weight: ", ";\n  outline: none;\n  &:hover {\n    border-color: ", ";\n  }\n  &:focus {\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    box-shadow: none;\n    color: ", ";\n  }\n"])), variants.fit, props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.400'), (0, _constant.get)('colors.functional.grey.800'), (0, _constant.get)('fontWeights.regular'), props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.functional.grey.600'), props => props.error ? (0, _constant.get)('colors.feedback.danger.normal') : (0, _constant.get)('colors.primary.blue.400'), props => props.error ? (0, _constant.get)('boxShadows.type.basic.danger') : (0, _constant.get)('boxShadows.type.basic.default'), (0, _constant.get)('colors.functional.grey.400'), (0, _constant.get)('colors.functional.grey.200'), (0, _constant.get)('colors.functional.grey.500'));
const Hint = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  padding: ", " 0 0 0;\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  text-align: ", ";\n"])), (0, _constant.get)('space.4'), (0, _constant.get)('colors.functional.grey.600'), (0, _constant.get)('fontSizes.14'), (0, _constant.get)('lineHeights.20'), props => props.hintPosition === 'right' ? 'right' : 'left');
const Components = exports.Components = {
  Wrapper,
  Area,
  TextArea,
  Hint
};